import { apiClient } from './client';
export const lookupsApi = {
    // TouchPoint types
    getTouchPointTypes: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/TouchPointTypes', { headers });
    },
    // Meeting types
    getCampaignMeetingTypes: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/CampaignMeetingTypes', { headers });
    },
    getWebMeetingTypes: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/WebMeetingTypes', { headers });
    },
    // Web statuses
    getWebStatuses: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/WebStatuses', { headers });
    },
    // Company size ranges
    getCompanySizeRanges: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/CompanySizeRanges', { headers });
    },
    // Time zones (uses specialized DTO with additional fields)
    getTimeZones: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/TimeZones', { headers });
    },
    // UTM sources
    getUtmSources: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/UtmSources', { headers });
    },
    // Social media platforms
    getPlatforms: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/Platforms', { headers });
    },
    // Web types
    getWebTypes: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/WebTypes', { headers });
    },
    // Authentication types
    getAuthenticationTypes: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/AuthenticationTypes', { headers });
    },
    // Campaign statuses
    getCampaignStatuses: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/CampaignStatuses', { headers });
    },
    // Company statuses
    getCompanyStatuses: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/CompanyStatuses', { headers });
    },
    // File statuses
    getFileStatuses: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/FileStatuses', { headers });
    },
    // Online event types
    getOnlineEventTypes: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/OnlineEventTypes', { headers });
    },
    // Online mode types
    getOnlineModeTypes: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/OnlineModeTypes', { headers });
    },
    // Speaker types
    getSpeakerTypes: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/SpeakerTypes', { headers });
    },
    // Workspace statuses
    getWorkspaceStatuses: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/WorkspaceStatuses', { headers });
    },
    // Countries
    getCountries: (ifNoneMatch) => {
        const headers = {};
        if (ifNoneMatch) {
            headers['If-None-Match'] = ifNoneMatch;
        }
        return apiClient.get('/api/App/Lookups/Countries', { headers });
    }
};
